import { render, staticRenderFns } from "./GenericDismissibleDialog.vue?vue&type=template&id=40bd650d&"
import script from "./GenericDismissibleDialog.vue?vue&type=script&lang=js&"
export * from "./GenericDismissibleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports